import {ICourierRatioRateConditionResponse} from "../../models/Courier";
import {IActionRatioRate} from "../actions/ratioRate";
import {CHANGE_RATIO_RATE_ERROR, CHANGE_RATIO_RATE_REQUEST, CHANGE_RATIO_RATE_SUCCESS} from "../constants/ratioRate";

export interface IRatioRateChangeState {
    data: ICourierRatioRateConditionResponse | null
    loading: boolean
    error: string
}

const initialState: IRatioRateChangeState = {
    data: null,
    loading: false,
    error: ''
}

export default function ratioRateChange(state = initialState, action: IActionRatioRate): IRatioRateChangeState {
    switch (action.type) {
        case CHANGE_RATIO_RATE_REQUEST:
            return {
                ...state,
                data: null,
                loading: true,
                error: ''
            };
        case CHANGE_RATIO_RATE_SUCCESS:
            const {data} = action.payload;
            return {
                ...state,
                data,
                loading: false,
                error: ''
            };
        case CHANGE_RATIO_RATE_ERROR:
            return {
                ...state,
                data: null,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
}